import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import { EbillSettingsInitials, GetEbillSettingsResponseListResponse } from './_clientTypes';
import { handleAxiosError } from '../../axios/handleAxiosError';
import { handleError } from '../../utils/handleError';
import { ODataParams } from '../_ODataTypes';
import { buildApiUrl } from '../../axios/urlCreator';
import { cachedGet } from '../../axios/responseCache';

const initialState: EbillSettingsInitials = {
    ebillSettings: null,
    loading: false,
    error: null
};

// Async action to fetch EbillSettings
export const getEbillSettingList = createAsyncThunk<GetEbillSettingsResponseListResponse, ODataParams | void>(
    'ebillSettings/getEbillSettingList',
    async (params, { rejectWithValue }) => {
        try {
            const queryParams = new URLSearchParams();
            if (params?.filter) queryParams.append('$filter', params.filter);
            if (params?.orderby) queryParams.append('$orderby', params.orderby);
            if (params?.top != null) queryParams.append('$top', params.top.toString());
            if (params?.skip != null) queryParams.append('$skip', params.skip.toString());

            return await cachedGet<GetEbillSettingsResponseListResponse>(buildApiUrl("client/ebillSettings", queryParams), 300_000);
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                return rejectWithValue(handleAxiosError(error));
            }
            return rejectWithValue(handleError(error));
        }
    }
);

const ebillSettingsSlice = createSlice({
    name: 'ebillSettings',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getEbillSettingList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getEbillSettingList.fulfilled, (state, action) => {
                state.loading = false;
                state.ebillSettings = action.payload;
            })
            .addCase(getEbillSettingList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    }
});

export default ebillSettingsSlice.reducer;
